var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"explain-wrapper"},[_c('p',{staticClass:"mt12 mb12 text"},[_vm._v("\n    说明\n  ")]),_vm._l((_vm.data),function(text){return _c('p',{key:text,staticClass:"text"},[_vm._v("\n    "+_vm._s(text)+"\n  ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }